import LocalizedStrings from 'localized-strings';

import { FeatureKey } from '../../types';

export default new LocalizedStrings({
  en: {
    accidentGuaranty: 'Accident cover',
    accountAccess: '{count} account access',
    accountAccesses: 'Up to {count} configurable accesses',
    accountantAccess: 'Dedicated access to your accountant',
    bulkTransfers: 'Bulk transfers',
    cashDeposit: 'Cash deposit',
    cashDeposits: '{count} cash deposits of up to {value} each',
    cashDepositSingle: '{count} cash deposit of up to {value}',
    checkDeposit: 'Check collections',
    checkDepositMonth: '{count} check collections',
    features: {
      [FeatureKey.AccountAccess]: 'Account access',
      [FeatureKey.Cards]: 'Cards',
      [FeatureKey.Transfers]: 'Transactions per month',
      [FeatureKey.SupplementaryFunctionalities]: 'Additional features',
      [FeatureKey.Support]: 'Assistance',
      [FeatureKey.GuarantyAndInsurance]: 'Warranties and insurance',
      [FeatureKey.InvoicingTool]: 'Invoicing tool',
    },
    illimitedVirtualCards: 'Unlimited virtual cards',
    invoicingTool: {
      automaticReminders: 'Automatic reminders',
      customerCatalog: 'Customer catalog',
      customMentions: 'Customizable mentions',
      itemsCatalog: 'Product and service catalogs',
      personalizedLogo: 'Logo on quotes and invoices',
      quotesAndInvoices: 'Unlimited creation of quotes and invoices',
    },
    legalAssistance: 'Legal assistance',
    materialProtections: 'Hardware protection',
    multipleAccounts: {
      titlePlural: `1 main account + {secondaryBankAccountsCount} wallets`,
      titleSingular: `1 main account + {secondaryBankAccountsCount} wallet`,
    },
    new: 'New',
    optionnalVirtualCard: 'Optional virtual cards',
    phoneCallBack: 'Request for a callback',
    phoneProtection: 'Phone protection',
    prioritySupport: 'Priority online support 7 days a week',
    recommended: 'Recommended for you',
    spentManagement: 'Spend management solution',
    standardSupport: 'Online support 7 days a week',
    transfers: '{count} bank transfers',
    virtualCards: '{count} virtual cards',
    whithdrawalsWithoutFees: '{count} withdrawals free of charge',
    withdrawalsToPay: 'Paid withdrawal',
  },
  fr: {
    accidentGuaranty: 'Garantie accident',
    accountAccess: '{count} accès au compte',
    accountAccesses: 'Jusqu’à {count} accès paramétrables',
    accountantAccess: 'Accès dédié pour votre comptable',
    bulkTransfers: 'Virements groupés',
    cashDeposit: 'Dépôt d’espèces',
    cashDeposits: '{count} dépôts d’espèces de {value} max. chacun',
    cashDepositSingle: '{count} dépôt d’espèces de {value} max.',
    checkDeposit: 'Encaissement de chèques',
    checkDepositMonth: '{count} encaissements de chèques',
    features: {
      [FeatureKey.AccountAccess]: 'Accès au compte',
      [FeatureKey.Cards]: 'Cartes',
      [FeatureKey.Transfers]: 'Mouvements par mois',
      [FeatureKey.SupplementaryFunctionalities]:
        'Fonctionnalités supplémentaires',
      [FeatureKey.Support]: 'Assistance',
      [FeatureKey.GuarantyAndInsurance]: 'Garanties et assurances',
      [FeatureKey.InvoicingTool]: 'Outil de facturation',
    },
    illimitedVirtualCards: 'Cartes virtuelles illimitées',
    invoicingTool: {
      automaticReminders: 'Relances automatiques',
      customerCatalog: 'Catalogue de clients',
      customMentions: 'Mentions personnalisables',
      itemsCatalog: 'Catalogue de produits et services',
      personalizedLogo: 'Logo sur devis et factures',
      quotesAndInvoices: 'Création illimitée de devis et factures',
    },
    legalAssistance: 'Assistance juridique',
    materialProtections: 'Protection matériel',
    multipleAccounts: {
      titlePlural: `1 compte principal + {secondaryBankAccountsCount} sous-comptes`,
      titleSingular: `1 compte principal + {secondaryBankAccountsCount} sous-compte`,
    },
    new: 'Nouveau',
    optionnalVirtualCard: 'Cartes virtuelles en option',
    phoneCallBack: 'Demande de rappel téléphonique',
    phoneProtection: 'Protection téléphone',
    prioritySupport: 'Support en ligne prioritaire 7/7j',
    recommended: 'Recommandé pour vous',
    spentManagement: 'Gestion des dépenses en équipe',
    standardSupport: 'Support en ligne 7/7j',
    transfers: '{count} mouvements bancaires',
    virtualCards: '{count} cartes virtuelles',
    whithdrawalsWithoutFees: '{count} retraits sans frais',
    withdrawalsToPay: 'Retrait payant',
  },
} as const);
